// extracted by mini-css-extract-plugin
module.exports = {"heading":"MenuHeading--heading--1JHTZ"};